<template>
  <div>
    <button
      data-tooltip="Subir excel"
      v-if="tokenUser['admin']"
      class="button is-link is-outlined tooltip"
      v-on:click="activeMenu"
    >
      <i class="material-icons">upload</i>
    </button>
    <article id="menuUpload" v-if="active" class="message is-link">
      <div class="message-header">
        <p>Subir archivo de FRP</p>
        <button
          class="delete"
          aria-label="delete"
          v-on:click="activeMenu"
        ></button>
      </div>

      <div v-if="!accept">
        <div class="message-body">
          <div class="field">
            <div class="file is-link is-boxed has-name">
              <label class="file-label">
                <input
                  ref="inputFile"
                  class="file-input"
                  type="file"
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  name="data"
                  v-on:change="onFileChange"
                />
                <span class="file-cta">
                  <span class="file-icon">
                    <i class="material-icons">file_upload</i>
                  </span>
                  <span class="file-label">
                    Subir archivo...
                  </span>
                </span>
                <span class="file-name has-text-centered">
                  <span class="is-size-7">{{ name }}</span>
                </span>
              </label>
            </div>
          </div>
          <div style="margin-top: 10px">
            <span class="is-size-7"
              >Recuerda subir los datos con la estructura especificada.
              <a
                :href="urlTemplateXlsx"
                download="Estructura de datos frsm.xlsx"
                class="has-text-dark"
                >aquí</a
              ></span
            >
          </div>
        </div>
        <div class="message-footer">
          <button
            class="button is-danger is-outlined is-small"
            v-on:click="deleteFile"
          >
            Eliminar<i class="material-icons" style="margin-left: 5px"
              >delete</i
            >
          </button>
          <button
            class="button is-link is-outlined is-small"
            :disabled="!dataFile"
            v-on:click="acceptFile"
          >
            Continuar<i class="material-icons" style="margin-left: 5px"
              >keyboard_arrow_right</i
            >
          </button>
        </div>
      </div>
      <div v-if="accept">
        <div class="message-body has-text-centered">
          <div>
            <span class="is-size-6">Nombre del informe*</span>
            <div class="field" style="margin-top: 10px">
              <div class="control" :class="save.init ? 'is-loading' : ''">
                <input
                  type="text"
                  class="input is-link is-rounded"
                  v-model="newName"
                  placeholder="Nombre*"
                />
              </div>
            </div>
          </div>
          <div style="margin-top: 15px">
            <span class="is-size-7"
              >En este modulo no se creara un informe automáticamente.</span
            >
          </div>
        </div>
        <div class="message-footer">
          <button
            class="button is-danger is-outlined is-small"
            :disabled="save.init"
            v-on:click="acceptFile"
          >
            Cancelar<i class="material-icons" style="margin-left: 5px"
              >delete</i
            >
          </button>
          <button
            class="button is-link is-outlined is-small"
            :disabled="!newName"
            v-on:click="saveFile"
          >
            Guardar<i class="material-icons" style="margin-left: 5px">save</i>
          </button>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
import { mapState } from "vuex";
import templateXlsx from "@/assets/files/Estructura_de_datos_frsm.xlsx";
export default {
  data() {
    return {
      urlTemplateXlsx: templateXlsx,
      dataFile: null,
      data: null,
      active: false,
      name: "...",
      filesAccept: [
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-excel",
      ],
      accept: false,
      newName: null,
      save: {
        init: false,
        progress: 0,
        error: "",
      },
      columnsValid: [
        // Bloque 03
        "RGO-03-Liderazgo",
        "RGO-03-Relaciones Sociales",
        "RGO-03-Retroalimentación",
        "RGO-03-Relación Colaboradores",
        // Bloque 04
        "RGO-04-Claridad de Rol",
        "RGO-04-Capacitación",
        "RGO-04-Participación y cambio",
        "RGO-04-Habilidades y conocimientos",
        "RGO-04-Control y Autonomía",
        // Bloque 05
        "RGO-05-Dem ambientales y fís",
        "RGO-05-Dem emocionales",
        "RGO-05-Dem cuantitativas",
        "RGO-05-Influencia trabajo entorno",
        "RGO-05-Exigencias cargo",
        "RGO-05-Demandas de carga mental",
        "RGO-05-Consistencia de Rol",
        "RGO-05-Dem Jornada de Trabajo",
        // Bloque 06
        "RGO-06-Recompensas del trabajo",
        "RGO-06-Reconocimiento",
        // Bloque 07
        "RGO-07-Tiempo Fuera del Trabajo",
        "RGO-07-Relaciones Familiares",
        "RGO-07-Comunicación",
        "RGO-07-Economía Familiar",
        "RGO-07-Vivienda",
        "RGO-07-Influencia Entorno Trabajo",
        "RGO-07-Desplazamiento",
        // Bloque 08
        "RGO-08-Optimismo",
        "RGO-08-Internalidad",
        "RGO-08-Autoestima",
        "RGO-08-Autoeficacia",
        // Bloque 10
        "RGO-10-Agotamiento Emocional",
        "RGO-10-Cinismo",
        "RGO-10-Pérdida de Autoeficacia",

        // Bloque Principal
        "RGO-02-TOTAL FRP INTRALABORALES",
        "RGO-03-LIDERAZGO Y RELACIONES SOCIALES EN EL TRABAJO",
        "RGO-04-CONTROL SOBRE EL TRABAJO",
        "RGO-05-DEMANDAS DEL TRABAJO",
        "RGO-06-RECOMPENSAS",
        "RGO-07-TOTAL FRP EXTRALABORALES",
        "RGO-08-INDICADOR CONDICIONES INDIVIDUALES",
        // Bloque
        "RGO-09-Engagement",
        "RGO-10-Burnout",
        "RGO-11-Estrés",
      ],
    };
  },
  computed: {
    ...mapState(["isOculto", "isMovil", "tokenUser"]),
  },
  methods: {
    activeMenu() {
      this.active = !this.active;
    },
    onFileChange(e) {
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      if (!this.filesAccept.includes(files[0].type)) return this.errorFile();
      this.dataFile = files[0];
      this.name = files[0].name;
    },
    errorFile() {
      this.$store.dispatch("notify", {
        message: `El archivo solo puede ser tipo Excel`,
        type: "is-danger",
      });
      this.deleteFile();
    },
    errorSave() {
      this.$store.dispatch("notify", {
        message: "Error!. No se pudo subir los datos.",
        type: "is-danger",
      });

      this.save.init = false;
      this.save.error = "Error al guarda intentalo de nuevo";
    },
    acceptFile() {
      this.accept = !this.accept;
    },
    deleteFile() {
      this.dataFile = null;
      this.name = "...";
      this.accept = false;
      this.newName = null;
      this.save = {
        init: false,
        finish: false,
        progress: 0,
      };

      if (this.$refs.inputFile) this.$refs.inputFile.value = null;

      return true;
    },
    saveFile() {
      const _this = this;

      const config = {
        title: "¿Estás seguro?",
        text: "Al guardar se remplazara el último informe creado",
        icon: "warning",
        showCancelButton: true,
        cancelButtonColor: "#de5b5b",
        confirmButtonText: "Sí, guardar",
      };

      this.$swal(config).then((result) => {
        if (result.isConfirmed) {
          const file = _this.dataFile;
          let task;
          if (file) {
            task = _this.$fire.refexcel(file);
            _this.save.init = true;
            task.on(
              "state_changed",
              (snapshot) => {
                const porcentaje =
                  (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                if (porcentaje > 10) {
                  _this.save.progress = porcentaje;
                }
              },
              (err) => {
                console.log("error subiendo el archivo", err);
              },
              async () => {
                try {
                  const url = await task.snapshot.ref.getDownloadURL();
                  const data = {
                    url: url,
                    dataFile: _this.dataFile,
                    name: this.newName,
                  };

                  if (data) {
                    this.$emit("sendDataFile", {
                      data,
                      success: (result) => {
                        if (!_this.validateColumns(result)) {
                          this.$store.dispatch("notify", {
                            message:
                              "Perfecto!. Datos Guardados correctamente.",
                          });
                        }
                        _this.deleteFile();
                      },
                      error: () => {
                        _this.errorSave();
                      },
                    });
                  }
                } catch (err) {
                  console.log("ocurrio un error", err);
                }
              }
            );
          }
        }
      });
    },
    validateColumns(data) {
      const errorColumns = [];
      const keys = Object.keys(data);

      for (const k of this.columnsValid) {
        if (!keys.includes(k)) errorColumns.push(k);
      }

      if (errorColumns.length) {
        const config = {
          title: "Datos guardados",
          html: `Al guardar se encontro errores en las columnas: <br/> <br/> ${errorColumns
            .toString()
            .replace(",", "<br/>")}`,
          icon: "warning",
        };

        this.$swal(config);
      }

      return errorColumns.length;
    },
  },
  watch: {},
};
</script>
<style>
#menuUpload {
  margin-top: 15px !important;
  position: absolute;
  z-index: 50;
  max-height: 16em !important;
  width: 16em !important;
}

#menuUpload .message-body {
  background-color: white;
  border-left: solid rgba(187, 187, 187, 0.99) 1px;
  border-right: solid rgba(187, 187, 187, 0.99) 1px;
  border-bottom: solid rgba(187, 187, 187, 0.99) 1px;
  border-radius: 0%;
}

#menuUpload .message-footer {
  background-color: white;
  border-left: solid rgba(187, 187, 187, 0.99) 1px;
  border-right: solid rgba(187, 187, 187, 0.99) 1px;
  border-bottom: solid rgba(187, 187, 187, 0.99) 1px;
  border-radius: 0 0 4px 4px;
  min-height: 30px;
  display: flex;
  justify-content: space-between;
  text-align: center;
  padding: 0.5em 1em;
}
</style>



// WEBPACK FOOTER //
// src/components/frpm/components/uploadFile.vue